// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ApolloClient from "rescript-apollo-client/src/ApolloClient.bs.js";
import * as Client from "@apollo/client";
import * as Config$LiveRoom from "../Config.bs.js";
import * as ApolloClient__Link_Ws from "rescript-apollo-client/src/@apollo/client/link/ws/ApolloClient__Link_Ws.bs.js";
import * as AuthTokenHook$LiveRoom from "./stores/AuthTokenHook.bs.js";
import * as ApolloClient__Utilities from "rescript-apollo-client/src/@apollo/client/utilities/ApolloClient__Utilities.bs.js";
import * as ApolloClient__Core_ApolloClient from "rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_ApolloClient.bs.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.bs.js";
import * as ApolloClient__Link_Http_HttpLink from "rescript-apollo-client/src/@apollo/client/link/http/ApolloClient__Link_Http_HttpLink.bs.js";
import * as ApolloClient__SubscriptionsTransportWs from "rescript-apollo-client/src/subscriptions-transport-ws/ApolloClient__SubscriptionsTransportWs.bs.js";
import * as ApolloClient__Cache_InMemory_InMemoryCache from "rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_InMemoryCache.bs.js";

function makeMockResult(data, error, loading, toJson) {
  return {
          data: Belt_Option.mapWithDefault(data, null, Curry.__1(toJson)),
          errors: (error == null) ? [] : [error],
          loading: loading
        };
}

function makeMockError(message, maybeDetail) {
  return {
          message: message,
          locations: undefined,
          path: undefined,
          nodes: undefined,
          source: undefined,
          position: undefined,
          originalError: null,
          extensions: Belt_Option.map(maybeDetail, (function (detail) {
                  return Js_dict.fromArray([[
                                "exception",
                                Js_dict.fromArray([[
                                        "details",
                                        detail
                                      ]])
                              ]]);
                }))
        };
}

var MockedProvider = {};

var Extentions = {
  makeMockResult: makeMockResult,
  makeMockError: makeMockError,
  MockedProvider: MockedProvider
};

function getErrorMessage(error) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(error.extensions, (function (extensions) {
                        return Belt_Option.flatMap(Js_dict.get(extensions, "exception"), Js_json.decodeObject);
                      })), (function (ex) {
                    return Belt_Option.flatMap(Js_dict.get(ex, "details"), Js_json.decodeString);
                  })), error.message);
}

function checkForStatusCode(errors, statusCode) {
  return Belt_Array.some(errors, (function (error) {
                return Caml_obj.equal(Belt_Option.flatMap(error.extensions, (function (extensions) {
                                  return Belt_Option.map(Belt_Option.flatMap(Js_dict.get(extensions, "statusCode"), Js_json.decodeNumber), (function (prim) {
                                                return prim | 0;
                                              }));
                                })), statusCode);
              }));
}

function getHeaders(authToken, param) {
  var headers = {};
  Belt_Option.forEach(authToken, (function (token) {
          headers["Authorization"] = "Bearer " + token + "";
        }));
  return headers;
}

function httpLink(authToken, param) {
  var headers = getHeaders(authToken, undefined);
  return ApolloClient__Link_Http_HttpLink.make((function (param) {
                return Config$LiveRoom.values.clientapiGraphqlUrl;
              }), undefined, undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined);
}

function wsLink(authToken, param) {
  if (authToken !== undefined) {
    return ApolloClient__Link_Ws.WebSocketLink.make(Config$LiveRoom.values.clientapiGraphqlSubscriptionsUrl, ApolloClient__SubscriptionsTransportWs.ClientOptions.make({
                    TAG: /* ConnectionParams */0,
                    _0: {
                      authToken: Caml_option.valFromOption(authToken)
                    }
                  }, undefined, true, undefined, undefined, undefined, undefined, undefined), undefined, undefined);
  } else {
    return ApolloClient__Link_Ws.WebSocketLink.make(Config$LiveRoom.values.clientapiGraphqlSubscriptionsUrl, ApolloClient__SubscriptionsTransportWs.ClientOptions.make(undefined, undefined, true, undefined, undefined, undefined, undefined, undefined), undefined, undefined);
  }
}

function splitDataLinks(httpLink, wsLink) {
  return ReasonMLCommunity__ApolloClient.Link.split((function (operation) {
                var definition = ApolloClient__Utilities.getOperationDefinition(operation.query);
                return Belt_Option.mapWithDefault(definition, false, (function (d) {
                              return d.operation === "subscription";
                            }));
              }), wsLink, httpLink);
}

function make(authToken, param) {
  var cache = ApolloClient__Cache_InMemory_InMemoryCache.make(undefined, undefined, undefined, undefined, undefined, undefined);
  var dataLinks;
  if (typeof authToken === "object") {
    if (authToken.NAME === "Authenticated") {
      var value = authToken.VAL.value;
      dataLinks = splitDataLinks(httpLink(value, undefined), wsLink(value, undefined));
    } else {
      dataLinks = httpLink(undefined, undefined);
    }
  } else {
    dataLinks = authToken === "Unauthenticated" ? splitDataLinks(httpLink(undefined, undefined), wsLink(undefined, undefined)) : httpLink(undefined, undefined);
  }
  var defaultOptions = ApolloClient__Core_ApolloClient.DefaultOptions.make(ApolloClient__Core_ApolloClient.DefaultMutateOptions.make(undefined, undefined, undefined, /* All */2, undefined, undefined), ApolloClient__Core_ApolloClient.DefaultQueryOptions.make(undefined, /* All */2, undefined, undefined), ApolloClient__Core_ApolloClient.DefaultWatchQueryOptions.make(undefined, /* All */2, undefined, undefined), undefined);
  return ApolloClient.make(undefined, undefined, undefined, Caml_option.some(dataLinks), cache, undefined, undefined, undefined, undefined, defaultOptions, undefined, undefined, undefined, undefined, "Auctionroom", undefined, undefined);
}

function Apollo$Provider(props) {
  var authToken = AuthTokenHook$LiveRoom.useToken("Apollo-LiveRoom");
  var client = React.useMemo((function () {
          return make(authToken, undefined);
        }), [authToken]);
  return React.createElement(Client.ApolloProvider, {
              client: client,
              children: props.children
            });
}

var Provider = {
  make: Apollo$Provider
};

export {
  Extentions ,
  getErrorMessage ,
  checkForStatusCode ,
  getHeaders ,
  httpLink ,
  wsLink ,
  splitDataLinks ,
  make ,
  Provider ,
}
/* react Not a pure module */
